<template>
  <div class="mb-3">
    <div class="row">
      <div class="col-2">
        <label class="form-label fw-bold">{{ label }}</label>
      </div>
      <div class="col-10 position-relative">
        <input
          type="text"
          class="form-control"
          v-model="texto"
          :placeholder="placeholder"
          @input="buscar"
          @blur="cerrarSiVacio"
          autocomplete="off"
        />
        <ul
          v-if="resultados.length"
          class="list-group position-absolute w-100"
          style="z-index:9999; max-height:200px; overflow-y:auto;"
        >
          <li
            v-for="item in resultados"
            :key="item[idField]"
            class="list-group-item list-group-item-action py-1 small"
            @mousedown.prevent="seleccionar(item)"
          >
            {{ formatItem(item) }}
          </li>
        </ul>
        <small v-if="modelValue" class="text-success">
          ✓ Seleccionado: {{ texto }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  name: "AutoComplete",
  props: {
    modelValue:   { default: null },
    endpoint:     { type: String, required: true },
    idField:      { type: String, required: true },
    labelField:   { type: String, required: true },
    placeholder:  { type: String, default: "Buscar..." },
    extraParams:  { type: Object, default: () => ({}) },
    initialLabel: { type: String, default: "" },
    label:        { type: String, default: "" },
    formatFn:     { type: Function, default: null },
  },
  data() {
    return {
      texto:      this.initialLabel ?? "",
      resultados: [],
    };
  },
  watch: {
    // ✅ immediate: arranca con el valor correcto desde el primer render
    // ✅ sin condición: siempre sincroniza cuando initialLabel cambia
    initialLabel: {
      immediate: true,
      handler(val) {
        this.texto = val ?? "";
      },
    },
    // ✅ si el padre limpia modelValue (ej: abrirModalCrear), limpia el texto
    modelValue(val) {
      if (val === null || val === undefined) {
        this.texto = "";
        this.resultados = [];
      }
    },
  },
  methods: {
    async buscar() {
      this.$emit("update:modelValue", null);
      if (this.texto.length < 2) {
        this.resultados = [];
        return;
      }
      try {
        const r = await api.get(this.endpoint, {
          params: { q: this.texto, ...this.extraParams },
        });
        this.resultados = r.data;
      } catch {
        this.resultados = [];
      }
    },
    seleccionar(item) {
      this.$emit("update:modelValue", item[this.idField]);
      this.texto      = this.formatItem(item);
      this.resultados = [];
    },
    // ✅ si el usuario borra el texto, limpia también el id emitido
    cerrarSiVacio() {
      if (!this.texto) {
        this.$emit("update:modelValue", null);
      }
      this.resultados = [];
    },
    formatItem(item) {
      if (this.formatFn) return this.formatFn(item);
      return item[this.labelField];
    },
  },
};
</script>